module.exports = __webpack_public_path__ + "order/img/membership-premium.97be57d7.svg";